// quantity-bundle-variants.js
// Funcionalidade para o Bundle de Quantidade com suporte a variantes

class QuantityBundle {
  constructor(container) {
    console.log('=== INITIALIZING QUANTITY BUNDLE ===');
    this.container = container;
    this.productId = container.dataset.productId;
    this.radioButtons = container.querySelectorAll('.quantity-bundle__radio');
    this.buyButton = container.querySelector('.quantity-bundle__buy-button');
    this.comparePriceEl = container.querySelector('.quantity-bundle__compare-price');
    this.currentPriceEl = container.querySelector('.quantity-bundle__current-price');
    this.pixPriceEl = container.querySelector('.quantity-bundle__pix-price');
    this.variantId = container.dataset.variantId;
    
    // Verificar se elementos essenciais existem
    if (!this.comparePriceEl || !this.currentPriceEl || !this.pixPriceEl) {
      console.error('❌ Essential elements missing:', {
        comparePriceEl: !!this.comparePriceEl,
        currentPriceEl: !!this.currentPriceEl,
        pixPriceEl: !!this.pixPriceEl
      });
      return;
    }

    // Inicializar variáveis
    this.bundleData = null;
    this.baseComparePrice = 0;
    this.baseCurrentPrice = 0;
    this.pixDiscount = parseFloat(this.pixPriceEl.dataset.pixDiscount) || 1;
    
    // Capturar descontos por quantidade
    this.quantityDiscounts = {
      1: parseFloat(container.dataset.option3Discount || container.getAttribute('data-option-3-discount')) || 0,
      2: parseFloat(container.dataset.option2Discount || container.getAttribute('data-option-2-discount')) || 0,
      3: parseFloat(container.dataset.option1Discount || container.getAttribute('data-option-1-discount')) || 0
    };
    
    console.log('Quantity discounts:', this.quantityDiscounts);
    
    this.selectedQuantity = this.getSelectedQuantity();
    this.currentVariantId = null; // Será definido em loadBundleData()
    
    this.init();
  }

  async init() {
    await this.loadVariantPrices();
    this.bindEvents();
    this.updatePrices();
    this.setupButton();
  }

  getCurrentVariantId() {
    // Primeiro, tentar pegar do seletor de variante do produto
    const variantSelector = document.querySelector('[name="id"]');
    if (variantSelector) {
      return variantSelector.value;
    }

    // Fallback: tentar pegar da URL ou dados globais
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
      return window.ShopifyAnalytics.meta.selectedVariantId;
    }

    // Último fallback: primeira variante disponível
    return this.container.dataset.variantId || null;
  }

  async loadVariantPrices() {
    try {
      const productData = await this.fetchProductData();
      const currentVariant = this.findVariantById(productData.variants, this.currentVariantId);
      
      if (currentVariant) {
        this.baseCurrentPrice = currentVariant.price / 100;
        this.baseComparePrice = (currentVariant.compare_at_price || currentVariant.price) / 100;
      } else {
        // Fallback para primeira variante disponível
        const firstVariant = productData.variants.find(v => v.available) || productData.variants[0];
        this.baseCurrentPrice = firstVariant.price / 100;
        this.baseComparePrice = (firstVariant.compare_at_price || firstVariant.price) / 100;
        this.currentVariantId = firstVariant.id;
      }
    } catch (error) {
      console.error('Erro ao carregar preços da variante:', error);
      // Usar valores padrão do elemento se houver erro
      this.baseComparePrice = parseFloat(this.comparePriceEl.dataset.comparePrice || 0) / 100;
      this.baseCurrentPrice = parseFloat(this.currentPriceEl.dataset.currentPrice || 0) / 100;
    }
  }

  findVariantById(variants, variantId) {
    return variants.find(variant => variant.id == variantId);
  }

  setupButton() {
    this.originalButtonText = this.buyButton.textContent;
    this.originalButtonStyle = this.buyButton.style.background;
  }

  bindEvents() {
    // Event listener para mudança de quantidade
    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.selectedQuantity = parseInt(e.target.value);
        this.updatePrices();
        this.updateVisualSelection();
      });
    });

    // Event listener para botão de compra
    this.buyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.addToCart();
    });

    // Event listener para clique nas opções
    this.container.querySelectorAll('.quantity-bundle__option').forEach(option => {
      option.addEventListener('click', (e) => {
        if (e.target.type !== 'radio') {
          const radio = option.querySelector('.quantity-bundle__radio');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
          }
        }
      });
    });

    // Event listener para mudança de variante do produto principal
    this.watchVariantChanges();

    // SOLUÇÃO BACKUP: Polling mais agressivo para garantir detecção
    //this.startVariantPolling();
  }

  startVariantPolling() {
    // Verificar mudanças a cada 500ms
    setInterval(() => {
      const currentVariantId = this.getCurrentVariantId();
      if (currentVariantId && currentVariantId !== this.currentVariantId) {
        console.log('🔄 POLLING: Variant change detected:', this.currentVariantId, '->', currentVariantId);
        this.handleVariantChange();
      }
    }, 500);
  }

  watchVariantChanges() {
    // Observar mudanças no seletor de variante principal
    const variantSelector = document.querySelector('[name="id"]');
    if (variantSelector) {
      variantSelector.addEventListener('change', async (e) => {
        this.currentVariantId = e.target.value;
        await this.loadVariantPrices();
        this.updatePrices();
      });
    }

    

    // Observar mudanças via eventos customizados (muitos temas usam isso)
    document.addEventListener('variant:change', async (e) => {
      if (e.detail && e.detail.variant) {
        this.currentVariantId = e.detail.variant.id;
        await this.loadVariantPrices();
        this.updatePrices();
      }
    });

    // Observar mudanças na URL (para temas que usam URL parameters)
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl && variantFromUrl !== this.currentVariantId) {
      this.currentVariantId = variantFromUrl;
      this.loadVariantPrices().then(() => this.updatePrices());
    }
  }

  getSelectedQuantity() {
    const checkedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    return checkedRadio ? parseInt(checkedRadio.value) : 1;
  }

  updatePrices() {
    const quantity = this.selectedQuantity;
    
    // Obter desconto para a quantidade selecionada
    const quantityDiscountPercent = this.quantityDiscounts[quantity] || 0;
    const quantityDiscountDecimal = quantityDiscountPercent / 100;
    
    // Calcular preços totais baseados na variante atual
    const totalComparePrice = this.baseComparePrice * quantity;
    const totalCurrentPriceBeforeDiscount = this.baseCurrentPrice * quantity;
    
    // Aplicar desconto por quantidade
    const totalCurrentPrice = totalCurrentPriceBeforeDiscount * (1 - quantityDiscountDecimal);
    
    // Aplicar desconto do Pix
    const pixDiscountDecimal = this.pixDiscount / 100;
    const totalPixPrice = totalCurrentPrice * (1 - pixDiscountDecimal);

    // Atualizar elementos no DOM
    this.comparePriceEl.textContent = this.formatPrice(totalComparePrice);
    this.currentPriceEl.textContent = this.formatPrice(totalCurrentPrice);
    
    // Atualizar preço do Pix mantendo o texto original
    const pixText = this.pixPriceEl.textContent.split(' ').slice(-2).join(' ');
    this.pixPriceEl.innerHTML = `${this.formatPrice(totalPixPrice)} ${pixText}`;
  }

  updateVisualSelection() {
    // Remove seleção visual de todas as opções
    this.container.querySelectorAll('.quantity-bundle__option').forEach(option => {
      option.classList.remove('quantity-bundle__option--selected');
    });

    // Adiciona seleção visual à opção ativa
    const selectedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    if (selectedRadio) {
      const selectedOption = selectedRadio.closest('.quantity-bundle__option');
      selectedOption.classList.add('quantity-bundle__option--selected');
    }
  }

  formatPrice(price) {
    return 'R$' + price.toFixed(2).replace('.', ',');
  }

  async addToCart() {
    if (this.buyButton.disabled) return;

    try {
      this.buyButton.disabled = true;
      this.buyButton.textContent = 'Adicionando...';
      // Usar a variante atual selecionada
      const cartData = {
        id: parseInt(this.currentVariantId ? this.currentVariantId : this.variantId),
        quantity: this.selectedQuantity,
        sections: this.getCartSections().join(','),
        sections_url: window.location.pathname
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      });

      if (response.ok) {
        const responseData = await response.json();
        
        this.showSuccessFeedback();
        await this.updateCartDrawer(responseData);
        
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: responseData }
        }));
        
        setTimeout(() => {
          this.openCartDrawer();
        }, 100);

      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao adicionar produto ao carrinho');
      }

    } catch (error) {
      console.error('Erro:', error);
      this.showErrorFeedback();
    }
  }

  async fetchProductData() {
    // Tentar dados globais primeiro
    if (window.product && window.product.variants) {
      return window.product;
    }

    if (window.ShopifyAnalytics?.meta?.product) {
      return window.ShopifyAnalytics.meta.product;
    }

    // Buscar via API
    const handle = this.getProductHandle();
    if (handle) {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        return await response.json();
      }
    }

    throw new Error('Não foi possível obter dados do produto');
  }

  getProductHandle() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/]+)/);
    return match ? match[1] : null;
  }

  showSuccessFeedback() {
    this.buyButton.textContent = '✓ Adicionado!';
    this.buyButton.style.background = '#4CAF50';
    
    setTimeout(() => {
      this.restoreButton();
    }, 2000);
  }

  showErrorFeedback() {
    this.buyButton.textContent = 'Erro - Tente novamente';
    this.buyButton.style.background = '#f44336';
    
    setTimeout(() => {
      this.restoreButton();
    }, 3000);
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.textContent = this.originalButtonText;
    this.buyButton.style.background = this.originalButtonStyle || '';
  }

  getCartSections() {
    return [
      'cart-drawer',
      'cart-icon-bubble'
    ];
  }

  async updateCartDrawer(responseData) {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      cartDrawer.classList.remove('is-empty');

      if (responseData.sections) {
        cartDrawer.renderContents({
          sections: responseData.sections,
          id: responseData.id
        });
      } else {
        const sectionsToRender = this.getCartSections();
        const sectionsData = {};
        
        for (const sectionId of sectionsToRender) {
          try {
            const sectionResponse = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
            if (sectionResponse.ok) {
              sectionsData[sectionId] = await sectionResponse.text();
            }
          } catch (error) {
            console.error(`Erro ao buscar seção ${sectionId}:`, error);
          }
        }

        cartDrawer.renderContents({
          sections: sectionsData,
          id: responseData.id
        });
      }
    } catch (error) {
      console.error('Erro ao atualizar cart drawer:', error);
    }
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.click();
      }
    }
  }
}

// Inicialização
function initQuantityBundles() {
  const bundles = document.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
}

// Auto-inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityBundles);
} else {
  initQuantityBundles();
}

// Re-inicializar quando seções forem carregadas dinamicamente
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const bundles = section.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
});

// Exportar para uso global
window.QuantityBundle = QuantityBundle;